<section id='month-selection'>
    <form [formGroup]="filterForm">
        <div id='schedule-calendar'>
            <div class="row calendar-header" style="margin: 0px;">
                <div class="month-text">{{ getMonth(selectedMonth)}}
                    <span class="load-previous-year" (click)="loadPreviousMonth()">
                        <mat-icon style="color: black;" aria-hidden="false">chevron_left</mat-icon>
                    </span>
                    <span class="load-next-year" (click)="loadNextMonth()">
                        <mat-icon style="color: black;" aria-hidden="false">chevron_right</mat-icon>
                    </span>
                </div>
                
                <div class="view-options-toggles row">
                    <div class='field-container change-view'>
                        <div class="field-input">
                            <mat-form-field appearance="outline">
                                <mat-select formControlName='viewType' disableOptionCentering>
                                    <mat-option [value]='obj.value' *ngFor="let obj of (viewType| alphabetize:'key':true)">
                                        {{ obj.key | translate}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class='select-today' [ngClass]="isTodaySelected ? 'selected':''" (click)="loadView('Today')" >{{ 'serviceSchedule.today' | translate }}</div>
                    <button mat-stroked-button class="date-grabber-shortcut" [matMenuTriggerFor]="dateGrabberMenu"
                        #dateGrabberTrigger="matMenuTrigger" aria-label="Open date grabber">
                        <span class="date-grabber-value">{{ dateGrabberSelectedDate | date : 'MM/dd/yyyy' }}</span>
                        <mat-icon>event</mat-icon>
                    </button>
                    <mat-menu #dateGrabberMenu="matMenu" [overlapTrigger]="false" xPosition="before" panelClass="date-grabber-menu-panel">
                        <div class="date-grabber-calendar-wrapper" (click)="$event.stopPropagation()">
                            <mat-calendar [selected]="dateGrabberSelectedDate" [startAt]="dateGrabberSelectedDate"
                                (selectedChange)="onDateGrabberSelected($event, dateGrabberTrigger)">
                            </mat-calendar>
                        </div>
                    </mat-menu>
                
                    <div class="view-options">
                        <div class='calendar-view' [ngClass]="viewMode == 'Day' ? 'selected':''" (click)="loadView('Day')">{{ 'serviceSchedule.day' | translate }}
                        </div>
                        <div class='calendar-view' [ngClass]="viewMode == 'Week' ? 'selected':''" (click)="loadView('Week')">{{ 'serviceSchedule.week' | translate}}
                        </div>
                        <div class='calendar-view' [ngClass]="viewMode == 'Month' ? 'selected':''"
                            (click)="loadView('Month')">{{ 'serviceSchedule.month' | translate}}
                        </div>
                    </div>
                </div>
            </div>
        <div class="row" style="margin: 0px;">
            <div class="refresh" style="margin-top: -20px;">
                <asp-icon class="icon d-inline-block" name="ic-20-utility-time-clock.svg" width="1.2rem" height='1.2rem'
                    color='var(--primary-toyota-color)'>
                </asp-icon>
                <span>{{ 'serviceSchedule.lastRefreshedAt' | translate}} {{refreshTime}}</span>
            </div>
        </div>
        <div class="asp-header" [ngClass]="{'sticky' : viewMode === 'Day'}">
        <div class="row" style="margin: 0px;" *ngIf="department !== 'PARTS'">
            <div id='filter-form'>
                <div class="field-container">
                    <div class="field-input">
                        <mat-form-field *ngIf="department === 'SERVICE'" appearance="outline">
                            <mat-select formControlName="teamId" disableOptionCentering>
                                <mat-option [value]='obj.id' *ngFor="let obj of (teamList | alphabetize:'name')" class="teamlist">
                                    <span >{{ obj.name }}</span>
                                    <div class="teamColor" [ngStyle]="{'background': obj.teamColor}"></div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-input">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="advisorId" disableOptionCentering >
                                <mat-option [value]='obj.id' *ngFor="let obj of (advisorList | alphabetize:'name')">
                                    {{ obj.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-input">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName='transportId' disableOptionCentering>
                                <mat-option [value]='obj.id'
                                    *ngFor="let obj of (transportList | alphabetize:'name')">
                                    {{ obj.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-input">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName='status' disableOptionCentering>
                                <mat-option [value]='obj.value'
                                    *ngFor="let obj of (statusList | alphabetize:'key':true)">
                                    {{ obj.key | translate}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-input" *ngIf="(department === 'SALES') && showDelivery">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName='appointmentType' disableOptionCentering>
                                <mat-option [value]='obj.value'
                                    *ngFor="let obj of (appointmentTypeList | alphabetize:'key':true)" class="teamlist">
                                    <span >{{ obj.key | translate }}</span>
                                    <div class="teamColor" [ngStyle]="{'background': obj.color}"></div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-input">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName='bookingSource' disableOptionCentering>
                                <mat-option [value]='obj.value'
                                    *ngFor="let obj of (bookingSources | alphabetize:'key':true)">
                                    {{ obj.key | translate}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row info-data">
                    <div class="hour-text" *ngIf="department === 'SERVICE'" > {{dayHours}}</div>
                    <div class="slot-text" > {{daySlots}}</div>
                    <div class="garage-text"  *ngIf="department === 'SERVICE'"  > {{garageEff}}</div>
                </div>
            </div>
            <div class="appt-type-container" *ngIf="department === 'SALES'">
                <div class="appt-type-identifier" *ngFor="let obj of appointmentTypeList">
                  <div class="square" [ngStyle]="{'background': obj.color}"></div>
                  <span class="appt-name" *ngIf="obj.value !== 'All Types'">{{obj.key | translate}}</span>
                </div>
            </div>
            
        </div>
        <div class="row" style="margin: 0px;" *ngIf="viewMode !== 'Month'">
            <app-appointment-by-week class="app-date-carousel" [ngClass]="viewMode == 'Week' ? 'week-view':''"
                                    [dateArray]="dateArray"
                                    [selectedDate]="selectedDate"
                                    [month]='selectedMonth'
                                    [department]='department'
                                    [viewMode]='viewMode'
                                    (dateChange)="onDateChange($event)"
                                    [filterValue]="filterForm.value"
                                    (dateRangeChange)='onDateRangeChange($event)'
                                    [isTodaySelected]="isTodaySelected"
                                    (loadDateRange)="loadDateRange($event)"
                              ></app-appointment-by-week>
        </div>
        </div>
        <div class="row" style="margin: 0px;"
            *ngIf="viewMode === 'Day' && this.filterForm.get('viewType')?.value !== 'Dispatch View' && this.filterForm.get('viewType')?.value !== 'List View'">
            <app-appointment-by-day class="app-time-carousel" [filterValue]="filterForm.value" [department]='department'
                [dateSlected]="currentSelection" [dealerStartTime]="dealerStartTime" (loadDateRange)="loadDateRange($event)">
            </app-appointment-by-day>
        </div>
        <div class="row w-100" style="margin: 0px;"
            *ngIf="viewMode === 'Day' && this.filterForm.get('viewType')?.value === 'List View'">
            <app-appointment-list-view class="w-100" [appointments]="appointments$ | async" [department]="department"
                [settings]="dealerSettings$ | async">
            </app-appointment-list-view>
        </div>
        <div class="zoomOption"
            *ngIf="viewMode === 'Day' && this.filterForm.get('viewType')?.value === 'Dispatch View' && ((appointments$ | async)?.length > 0)">
            <span class="zoom-content" (click)="zoomTrigger('in')" [ngClass]="{'disabled': zoomCount == 8 }">
                <mat-icon style="color: black;" aria-hidden="false">zoom_in</mat-icon>
            </span>
            <span class="zoom-content" (click)="zoomTrigger('out')" [ngClass]="{'disabled': zoomCount == 2 }">
                <mat-icon style="color: black;" aria-hidden="false">zoom_out</mat-icon>
            </span>
            </div>
        <div class="row" style="margin: 0px;"
            *ngIf="viewMode === 'Day' && this.filterForm.get('viewType')?.value === 'Dispatch View' ">
            <app-appointment-dispatch-view class="app-day-dispatch-view" [department]='department' [filterValue]="filterForm.value"
             [zoomVal]='zoomCount' (emitAppointmentDetails)="emitApptDetails($event)" [selectedDate]="selectedDate"></app-appointment-dispatch-view>
        </div>
        <div class="row" style="margin: 0px;" *ngIf="viewMode === 'Month'">
            <app-appointment-by-month class="app-month-view" [department]='department' (dateChange)="onDateChange($event)"
                [month]='selectedMonth' (dateRangeChange)='onDateRangeChange($event)' [selectedDate]="selectedDate"
                [dateArray]="dateArray" (loadDateRange)="loadDateRange($event)"></app-appointment-by-month>
        </div>
        </div>
    </form>
</section>